/* eslint-disable react/jsx-wrap-multilines */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { ChangeGroupModalComponent } from '../change-group-modal';
import { ChangeWayModalComponent } from '../change-way-modal';
import './styles.less';
import { ordersRegroupAction, orderGroupRegroupAction, orderGroupResetAction } from '../../actions';
import { CreateReqModalComponent } from '../create-req-modal';
import { PlanningModalComponent } from '../planning-modal';

const GroupContextWrapper = ({
	contextMenu,
	setContextMenu,
	selectedCollection,
	selectedOrders,
	group,
	onRegroup,
	onOrderRegroup,
	onReset,
	isWithWays,
}) => {
	const isProcess = group?.process;

	const processStatus = group?.process_status;

	if ((isProcess && processStatus === 'active') || (isWithWays && !isProcess)) return null;

	if (isProcess && (selectedCollection?.length > 0 || selectedOrders?.length > 0)) return null;

	const count = (selectedCollection?.length ?? 0) + (selectedOrders?.length ?? 0);

	let disabled = false;
	if (count === 0 && group?.orders_count === 0) {
		disabled = true;
	}

	const [isChangeGroupModalShown, setIsChangeGroupModalShown] = useState(false);

	const [isChangeWayModalShown, setIsChangeWayModalShown] = useState(false);

	const [isCreateReqModalShown, setIsCreateReqModalShown] = useState(false);

	const [isPlanningModalShown, setIsPlanningModalShown] = useState(false);

	const handleClose = () => {
		setContextMenu(null);
	};

	const changeGroupModal = () => {
		setContextMenu(null);
		setIsChangeGroupModalShown(true);
	};

	const changeWayModal = () => {
		setContextMenu(null);
		setIsChangeWayModalShown(true);
	};

	const createReqModal = () => {
		setContextMenu(null);
		setIsCreateReqModalShown(true);
	};

	const planningModal = () => {
		setContextMenu(null);
		setIsPlanningModalShown(true);
	};

	const regroup = () => {
		setContextMenu(null);

		if (count > 0) {
			onOrderRegroup({ collection: selectedCollection, orders: selectedOrders });
		} else {
			onRegroup({ row: group });
		}
	};

	const reset = () => {
		setContextMenu(null);
		if (count === 0) {
			onReset({ row: group });
		}
	};

	return (
		<>
			<Menu
				className="group-context-menu"
				open={contextMenu !== null}
				onClose={handleClose}
				anchorReference="anchorPosition"
				anchorPosition={
					contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined
				}
			>
				{!isWithWays ? (
					<>
						{group?.id === 1 && count === 0 && !isProcess && (
							<MenuItem disabled={disabled} onClick={regroup}>
								Распределить по группам{count ? ` (${count})` : ''}
							</MenuItem>
						)}

						{group?.id && !isProcess && !count && (
							<MenuItem disabled={disabled} onClick={planningModal}>
								Маршрутизация
							</MenuItem>
						)}

						<MenuItem disabled={disabled} onClick={changeGroupModal}>
							Переместить в группу{count ? ` (${count})` : ''}
						</MenuItem>

						{!isProcess && (
							<>
								<MenuItem disabled={disabled} onClick={changeWayModal}>
									Переместить в маршрут{count ? ` (${count})` : ''}
								</MenuItem>
								<MenuItem disabled={disabled} onClick={createReqModal}>
									Создать заявку{count ? ` (${count})` : ''}
								</MenuItem>
							</>
						)}
					</>
				) : (
					<>
						{isProcess && (
							<MenuItem disabled={disabled} onClick={reset}>
								Вернуть заказы
							</MenuItem>
						)}
					</>
				)}
			</Menu>

			{isChangeGroupModalShown && (
				<ChangeGroupModalComponent
					isModalShown={isChangeGroupModalShown}
					setIsModalShown={setIsChangeGroupModalShown}
					collection={selectedCollection}
					orders={selectedOrders}
					group={group}
				/>
			)}

			{isChangeWayModalShown && (
				<ChangeWayModalComponent
					isModalShown={isChangeWayModalShown}
					setIsModalShown={setIsChangeWayModalShown}
					collection={selectedCollection}
					orders={selectedOrders}
					group={group}
				/>
			)}

			{isCreateReqModalShown && (
				<CreateReqModalComponent
					isModalShown={isCreateReqModalShown}
					setIsModalShown={setIsCreateReqModalShown}
					collection={selectedCollection}
					orders={selectedOrders}
					group={group}
				/>
			)}

			{isPlanningModalShown && (
				<PlanningModalComponent
					isModalShown={isPlanningModalShown}
					setIsModalShown={setIsPlanningModalShown}
					group={group}
				/>
			)}
		</>
	);
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = {
	onRegroup: orderGroupRegroupAction,
	onOrderRegroup: ordersRegroupAction,
	onReset: orderGroupResetAction,
};

export const GroupContextComponent = connect(mapStateToProps, mapDispatchToProps)(GroupContextWrapper);

GroupContextWrapper.propTypes = {
	contextMenu: PropTypes.object,
	setContextMenu: PropTypes.func,
	selectedCollection: PropTypes.array,
	selectedOrders: PropTypes.array,
	group: PropTypes.object,
	onRegroup: PropTypes.func,
	onOrderRegroup: PropTypes.func,
	onReset: PropTypes.func,
	isWithWays: PropTypes.bool,
};
